module.exports = __webpack_public_path__ + "img/worst_war.492d89ac.png";